// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#bidbox-widget {
  /*
  background-color: #034FA0;
   */
}
#bidbox-widget .offer-amount-input {
  font-size: 18px;
}
#bidbox-widget .loadingSpacer {
  min-height: 250px;
}
#bidbox-widget .bid-too-low {
  font-weight: 500;
}
#bidbox-widget .submit-bid-btn, #bidbox-widget .submit-bid-btn:focus {
  background-color: var(--primaryButtonColour) !important;
}
#bidbox-widget .accepted {
  color: var(--successColour);
  font-weight: 600;
}
#bidbox-widget .accepted-2 {
  font-size: 0.875rem;
  font-weight: 500;
}
#bidbox-widget .buy-now-price {
  font-weight: 600;
  font-size: 1.8rem;
  line-height: 1.8rem;
}
#bidbox-widget .underwrite {
  font-size: 0.875rem;
}
#bidbox-widget .underwrite .reserve-price {
  font-size: 0.9rem;
  font-weight: 600;
}
#bidbox-widget #bidbox {
  padding-bottom: 5px;
  border: 2px solid var(--secondaryButtonColour);
}
#bidbox-widget .gavel {
  font-size: 1.5rem;
}
#bidbox-widget .gavel-1 {
  transform: rotate(-45deg);
}
#bidbox-widget .gavel-3 {
  transform: rotate(45deg);
}
#bidbox-widget .ggg {
  font-weight: 600;
  font-size: 0.875rem;
}
#bidbox-widget .ggg.ggg-1 {
  color: var(--successColour) !important;
}
#bidbox-widget .ggg.ggg-2 {
  color: darkorange !important;
}
#bidbox-widget .ggg.ggg-3 {
  color: var(--errorColour) !important;
}
#bidbox-widget .align-buttons {
  min-width: 100px;
}
#bidbox-widget .proxy-bid-amt {
  font-size: 1rem;
  font-weight: bold;
  padding-bottom: 7px;
}
#bidbox-widget .smallprint {
  font-size: 11px;
}
#bidbox-widget .sold-status-sold {
  font-size: 2rem;
  font-weight: 600;
  letter-spacing: -1px;
}
#bidbox-widget .your-advert {
  background-color: var(--secondaryButtonColour);
  color: var(--colour3);
}
#bidbox-widget .box-with-you {
  border: 2px solid #0FBD56 !important;
}
#bidbox-widget .box-against-you {
  border: 2px solid #c00 !important;
}
#bidbox-widget .bid-with-vendor {
  background-color: var(--primaryButtonColour) !important;
  color: var(--colour3) !important;
}
#bidbox-widget .bid-too-late {
  background-color: var(--errorColour);
  color: var(--colour3);
}
#bidbox-widget .make-offer-button {
  font-size: 0.8rem;
  font-weight: 500;
}
#bidbox-widget .rejected {
  color: var(--errorColour);
  font-size: 0.875rem;
}
#bidbox-widget .with-vendor table td {
  font-weight: bold;
  line-height: 22px;
}
#bidbox-widget .with-vendor table td.tick {
  font-size: 30px;
  padding-right: 10px;
}
#bidbox-widget .accepted table td {
  font-weight: bold;
  line-height: 22px;
}
#bidbox-widget .accepted table td.tick {
  font-size: 30px;
  padding-right: 10px;
}
#bidbox-widget .lot-ended {
  font-size: 14px;
}
#bidbox-widget .won {
  background-color: var(--successColour);
  color: var(--colour3);
  font-weight: 400;
  cursor: pointer;
  font-size: 0.875rem;
  padding: 4px;
}
#bidbox-widget .won .info {
  font-size: 0.7rem;
  vertical-align: middle;
}
#bidbox-widget .sold-status-provisional {
  font-size: 1.5rem;
  font-weight: 600;
}
#bidbox-widget .sold-status-withdrawn, #bidbox-widget .sold-status-unsold {
  font-size: 1.2rem;
  font-weight: 600;
  text-transform: uppercase;
}
#bidbox-widget .sold-status-title {
  font-size: 0.875rem;
  font-weight: 400;
}
#bidbox-widget .confirm-bin-button {
  min-width: 100px;
}
#bidbox-widget .price-label {
  text-transform: uppercase;
  font-weight: 600;
  font-size: 0.875rem;
}
#bidbox-widget .price {
  font-weight: 700;
  font-size: 2.5rem;
  line-height: 2.5rem;
  color: var(--linkColour);
}
#bidbox-widget .price.reserve-price {
  font-size: 1rem;
}
#bidbox-widget .delivery-smallprint {
  font-size: 0.8rem;
  font-weight: 400;
}
#bidbox-widget .reserve-status {
  font-weight: 500;
  font-size: 0.9rem;
  text-align: center;
  background-color: #e9ecf0;
  color: var(--textColour);
  display: inline-block;
  line-height: 1.4rem;
  border-radius: 0.7rem;
  padding: 0 10px;
}
#bidbox-widget .fees {
  font-size: 13px;
  font-weight: 400;
  color: var(--textLabelColour);
}
#bidbox-widget .time-left {
  text-align: center;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 0.875rem;
  margin-top: 15px;
}
#bidbox-widget .time-left .timer-words {
  font-weight: 700;
  font-size: 0.9rem;
  color: var(--linkColour);
}
#bidbox-widget .buy-now-label {
  font-weight: 500;
}
#bidbox-widget .bid-entry {
  padding: 16px !important;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
}
#bidbox-widget .your-max-bid {
  font-weight: 600;
  font-size: 0.875rem;
  text-transform: uppercase;
  color: var(--linkColour);
}
#bidbox-widget .your-max-bid .your-max-bid-amount {
  font-weight: 700;
  font-size: 0.9rem;
  color: var(--linkColour);
}
#bidbox-widget .currency-symbol {
  position: absolute;
  left: 11px;
  top: 1px;
  display: inline-block;
  font-size: 24px;
  line-height: 51px;
  font-weight: 600;
  color: var(--linkColour);
}
#bidbox-widget #bidAmt2 {
  font-weight: 700;
  font-size: 24px;
  line-height: 24px;
  padding-left: 35px !important;
  padding-top: 8px;
  padding-bottom: 8px;
  border: 1.5px solid var(--primaryButtonColour) !important;
}
#bidbox-widget #bidAmt2::placeholder {
  color: #808080;
  font-size: 18px;
  line-height: 18px;
  display: inline-block;
  letter-spacing: -1px;
  transform: translateY(-1px);
}
#bidbox-widget .table-label {
  color: var(--textLabelColour);
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
}
#bidbox-widget .bidding-position {
  font-weight: 500;
  padding: 5px;
  color: var(--textColour);
  background-color: #f0f0f0;
  font-size: 0.85rem;
  border-top-right-radius: calc(var(--widgetBorderRadius) - 1px);
  border-top-left-radius: calc(var(--widgetBorderRadius) - 1px);
}
#bidbox-widget .w-40 {
  width: 40%;
}
#bidbox-widget .w-60 {
  width: 60%;
}
#bidbox-widget .bid-state {
  display: flex;
  align-items: center;
}
#bidbox-widget .bid-state .bid-state-inner {
  padding-top: 15px;
  padding-bottom: 15px;
  flex-grow: 1;
}
#bidbox-widget .timer-date {
  font-size: 11px;
  color: var(--textLabelColour);
  font-weight: 500;
  text-transform: uppercase;
}
#bidbox-widget .with-you {
  background-color: #09B677;
  color: var(--colour3);
}
#bidbox-widget .against-you {
  background-color: var(--dangerColour);
  color: var(--colour3);
}
#bidbox-widget #bidAmt {
  font-weight: 600 !important;
}
#bidbox-widget .bid-error {
  background-color: var(--dangerColour);
  color: #fff;
  padding: 3px;
  font-size: 12px;
  font-weight: 500;
  border-radius: 3px;
  margin-top: 5px;
}
#bidbox-widget .ended {
  font-size: 1rem;
  font-weight: 500;
  background-color: var(--dangerColour);
  color: var(--colour3);
}
#bidbox-widget .tsandcs {
  font-size: 0.75rem;
}
#bidbox-widget #bid-amount-box {
  width: 100%;
  margin: 0 auto;
  text-align: center;
}
#bidbox-widget .minimum-bid {
  font-size: 12px;
  color: #666;
}
#bidbox-widget .minimum-bid .minimum-bid-amount {
  font-weight: 500;
}
#bidbox-widget h1 {
  font-size: 24px;
  font-weight: 500;
}
#bidbox-widget h2 {
  font-size: 16px;
  font-weight: 400;
}
#bidbox-widget .watchlist-state, #bidbox-widget .message-seller {
  font-size: 0.8rem;
  font-weight: 500;
}
#bidbox-widget .buy-now-time-left {
  text-align: center;
  font-weight: 500;
  text-transform: uppercase;
  font-size: 0.75rem;
  margin-top: 15px;
}`, "",{"version":3,"sources":["webpack://./projects/remarq/src/app/components/main/advert/advert-bid-box/advert-bid-box.component.scss"],"names":[],"mappings":"AAAA;EA4NE;;IAAA;AAxNF;AAFE;EACE,eAAA;AAIJ;AADE;EACE,iBAAA;AAGJ;AAAE;EACE,gBAAA;AAEJ;AACE;EACE,uDAAA;AACJ;AAEE;EACE,2BAAA;EACA,gBAAA;AAAJ;AAGE;EACE,mBAAA;EACA,gBAAA;AADJ;AAIE;EAEE,gBAAA;EACA,iBAAA;EACA,mBAAA;AAHJ;AAME;EACE,mBAAA;AAJJ;AAMI;EACE,iBAAA;EACA,gBAAA;AAJN;AAQE;EACE,mBAAA;EACA,8CAAA;AANJ;AASE;EACE,iBAAA;AAPJ;AAUE;EACE,yBAAA;AARJ;AAcE;EACE,wBAAA;AAZJ;AAgBE;EACE,gBAAA;EACA,mBAAA;AAdJ;AAgBI;EACE,sCAAA;AAdN;AAiBI;EACE,4BAAA;AAfN;AAkBI;EACE,oCAAA;AAhBN;AAoBE;EAEE,gBAAA;AAnBJ;AAuBE;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;AArBJ;AAwBE;EACE,eAAA;AAtBJ;AAyBE;EACE,eAAA;EACA,gBAAA;EACA,oBAAA;AAvBJ;AA0BE;EACE,8CAAA;EACA,qBAAA;AAxBJ;AA2BE;EACE,oCAAA;AAzBJ;AA4BE;EACE,iCAAA;AA1BJ;AA6BE;EACE,uDAAA;EACA,gCAAA;AA3BJ;AA8BE;EACE,oCAAA;EACA,qBAAA;AA5BJ;AA+BE;EACE,iBAAA;EACA,gBAAA;AA7BJ;AAiCE;EACE,yBAAA;EACA,mBAAA;AA/BJ;AAkCE;EACE,iBAAA;EACA,iBAAA;AAhCJ;AAkCI;EACE,eAAA;EACA,mBAAA;AAhCN;AAoCE;EACE,iBAAA;EACA,iBAAA;AAlCJ;AAoCI;EACE,eAAA;EACA,mBAAA;AAlCN;AAsCE;EACE,eAAA;AApCJ;AAuCE;EACE,sCAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;AArCJ;AAuCI;EACE,iBAAA;EACA,sBAAA;AArCN;AAyCE;EACE,iBAAA;EACA,gBAAA;AAvCJ;AA0CE;EACE,iBAAA;EACA,gBAAA;EACA,yBAAA;AAxCJ;AA2CE;EACE,mBAAA;EACA,gBAAA;AAzCJ;AA4CE;EACE,gBAAA;AA1CJ;AA6CE;EACE,yBAAA;EACA,gBAAA;EACA,mBAAA;AA3CJ;AA8CE;EAEE,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,wBAAA;AA7CJ;AA+CI;EACE,eAAA;AA7CN;AAiDE;EAEE,iBAAA;EACA,gBAAA;AAhDJ;AAuDE;EAEE,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,wBAAA;EACA,qBAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;AAtDJ;AA0DE;EAEE,eAAA;EACA,gBAAA;EACA,6BAAA;AAzDJ;AA4DE;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;AA1DJ;AA4DI;EACE,gBAAA;EACA,iBAAA;EACA,wBAAA;AA1DN;AA+DE;EAEE,gBAAA;AA9DJ;AAkEE;EAEE,wBAAA;EAEA,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;AAlEJ;AAuEE;EAEE,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,wBAAA;AAtEJ;AAwEI;EACE,gBAAA;EACA,iBAAA;EACA,wBAAA;AAtEN;AA2EE;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,wBAAA;AAzEJ;AA4EE;EAEE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,6BAAA;EACA,gBAAA;EACA,mBAAA;EACA,yDAAA;AA3EJ;AA6EI;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,oBAAA;EACA,2BAAA;AA3EN;AA+EE;EAEE,6BAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;AA9EJ;AAkFE;EACE,gBAAA;EACA,YAAA;EACA,wBAAA;EACA,yBAAA;EACA,kBAAA;EACA,8DAAA;EACA,6DAAA;AAhFJ;AAmFE;EACE,UAAA;AAjFJ;AAoFE;EACE,UAAA;AAlFJ;AAqFE;EACE,aAAA;EACA,mBAAA;AAnFJ;AAqFI;EACE,iBAAA;EACA,oBAAA;EACA,YAAA;AAnFN;AAuFE;EAEE,eAAA;EACA,6BAAA;EACA,gBAAA;EACA,yBAAA;AAtFJ;AA2FE;EACE,yBAAA;EACA,qBAAA;AAzFJ;AA4FE;EACE,qCAAA;EACA,qBAAA;AA1FJ;AA6FE;EACE,2BAAA;AA3FJ;AA8FE;EAEE,qCAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AA7FJ;AAiGE;EACE,eAAA;EACA,gBAAA;EACA,qCAAA;EACA,qBAAA;AA/FJ;AAkGE;EACE,kBAAA;AAhGJ;AAmGE;EACE,WAAA;EACA,cAAA;EACA,kBAAA;AAjGJ;AAoGE;EAEE,eAAA;EACA,WAAA;AAnGJ;AAqGI;EACE,gBAAA;AAnGN;AAuGE;EACE,eAAA;EACA,gBAAA;AArGJ;AAwGE;EACE,eAAA;EACA,gBAAA;AAtGJ;AAyGE;EACE,iBAAA;EACA,gBAAA;AAvGJ;AA0GE;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AAxGJ","sourcesContent":["#bidbox-widget {\n\n  .offer-amount-input {\n    font-size: 18px;\n  }\n\n  .loadingSpacer {\n    min-height: 250px;\n  }\n\n  .bid-too-low {\n    font-weight: 500;\n  }\n\n  .submit-bid-btn, .submit-bid-btn:focus {\n    background-color: var(--primaryButtonColour) !important;\n  }\n\n  .accepted {\n    color: var(--successColour);\n    font-weight: 600;\n  }\n\n  .accepted-2 {\n    font-size: 0.875rem;\n    font-weight: 500;\n  }\n\n  .buy-now-price {\n\n    font-weight: 600;\n    font-size: 1.8rem;\n    line-height: 1.8rem;\n  }\n\n  .underwrite {\n    font-size: 0.875rem;\n\n    .reserve-price {\n      font-size: 0.9rem;\n      font-weight: 600;\n    }\n  }\n\n  #bidbox {\n    padding-bottom: 5px;\n    border: 2px solid var(--secondaryButtonColour);\n  }\n\n  .gavel {\n    font-size: 1.5rem;\n  }\n\n  .gavel-1 {\n    transform: rotate(-45deg)\n  }\n\n  .gavel-2 {\n  }\n\n  .gavel-3 {\n    transform: rotate(45deg);\n  }\n\n\n  .ggg {\n    font-weight: 600;\n    font-size: 0.875rem;\n\n    &.ggg-1 {\n      color: var(--successColour) !important;\n    }\n\n    &.ggg-2 {\n      color: darkorange !important;\n    }\n\n    &.ggg-3 {\n      color: var(--errorColour) !important;\n    }\n  }\n\n  .align-buttons {\n\n    min-width: 100px;\n\n  }\n\n  .proxy-bid-amt {\n    font-size: 1rem;\n    font-weight: bold;\n    padding-bottom: 7px;\n  }\n\n  .smallprint {\n    font-size: 11px;\n  }\n\n  .sold-status-sold {\n    font-size: 2rem;\n    font-weight: 600;\n    letter-spacing: -1px;\n  }\n\n  .your-advert {\n    background-color: var(--secondaryButtonColour);\n    color: var(--colour3);\n  }\n\n  .box-with-you {\n    border: 2px solid #0FBD56 !important;\n  }\n\n  .box-against-you {\n    border: 2px solid #c00 !important;\n  }\n\n  .bid-with-vendor {\n    background-color: var(--primaryButtonColour) !important;\n    color: var(--colour3) !important;\n  }\n\n  .bid-too-late {\n    background-color: var(--errorColour);\n    color: var(--colour3);\n  }\n\n  .make-offer-button {\n    font-size: 0.8rem;\n    font-weight: 500;\n\n  }\n\n  .rejected {\n    color: var(--errorColour);\n    font-size: 0.875rem;\n  }\n\n  .with-vendor table td {\n    font-weight: bold;\n    line-height: 22px;\n\n    &.tick {\n      font-size: 30px;\n      padding-right: 10px;\n    }\n  }\n\n  .accepted table td {\n    font-weight: bold;\n    line-height: 22px;\n\n    &.tick {\n      font-size: 30px;\n      padding-right: 10px;\n    }\n  }\n\n  .lot-ended {\n    font-size: 14px;\n  }\n\n  .won {\n    background-color: var(--successColour);\n    color: var(--colour3);\n    font-weight: 400;\n    cursor: pointer;\n    font-size: 0.875rem;\n    padding: 4px;\n\n    .info {\n      font-size: 0.7rem;\n      vertical-align: middle;\n    }\n  }\n\n  .sold-status-provisional {\n    font-size: 1.5rem;\n    font-weight: 600;\n  }\n\n  .sold-status-withdrawn, .sold-status-unsold {\n    font-size: 1.2rem;\n    font-weight: 600;\n    text-transform: uppercase;\n  }\n\n  .sold-status-title {\n    font-size: 0.875rem;\n    font-weight: 400;\n  }\n\n  .confirm-bin-button {\n    min-width: 100px;\n  }\n\n  .price-label {\n    text-transform: uppercase;\n    font-weight: 600;\n    font-size: 0.875rem;\n  }\n\n  .price {\n\n    font-weight: 700;\n    font-size: 2.5rem;\n    line-height: 2.5rem;\n    color: var(--linkColour);\n\n    &.reserve-price {\n      font-size: 1rem;\n    }\n  }\n\n  .delivery-smallprint {\n\n    font-size: 0.8rem;\n    font-weight: 400;\n  }\n\n  /*\n  background-color: #034FA0;\n   */\n\n  .reserve-status {\n\n    font-weight: 500;\n    font-size: 0.9rem;\n    text-align: center;\n    background-color: #e9ecf0;\n    color: var(--textColour);\n    display: inline-block;\n    line-height: 1.4rem;\n    border-radius: 0.7rem;\n    padding: 0 10px;\n\n  }\n\n  .fees {\n\n    font-size: 13px;\n    font-weight: 400;\n    color: var(--textLabelColour);\n  }\n\n  .time-left {\n    text-align: center;\n    font-weight: 600;\n    text-transform: uppercase;\n    font-size: 0.875rem;\n    margin-top: 15px;\n\n    .timer-words {\n      font-weight: 700;\n      font-size: 0.9rem;\n      color: var(--linkColour);\n\n    }\n  }\n\n  .buy-now-label {\n\n    font-weight: 500;\n\n  }\n\n  .bid-entry {\n\n    padding: 16px !important;\n\n    height: 100%;\n    width: 100%;\n    display: flex;\n    align-items: center;\n\n\n  }\n\n  .your-max-bid {\n\n    font-weight: 600;\n    font-size: 0.875rem;\n    text-transform: uppercase;\n    color: var(--linkColour);\n\n    .your-max-bid-amount {\n      font-weight: 700;\n      font-size: 0.9rem;\n      color: var(--linkColour);\n\n    }\n  }\n\n  .currency-symbol {\n    position: absolute;\n    left: 11px;\n    top: 1px;\n    display: inline-block;\n    font-size: 24px;\n    line-height: 51px;\n    font-weight: 600;\n    color: var(--linkColour);\n  }\n\n  #bidAmt2 {\n\n    font-weight: 700;\n    font-size: 24px;\n    line-height: 24px;\n    padding-left: 35px !important;\n    padding-top: 8px;\n    padding-bottom: 8px;\n    border: 1.5px solid var(--primaryButtonColour) !important;\n\n    &::placeholder {\n      color: #808080;\n      font-size: 18px;\n      line-height: 18px;\n      display: inline-block;\n      letter-spacing: -1px;\n      transform: translateY(-1px);\n    }\n  }\n\n  .table-label {\n\n    color: var(--textLabelColour);\n    font-size: 0.75rem;\n    font-weight: 600;\n    text-transform: uppercase;\n\n  }\n\n  .bidding-position {\n    font-weight: 500;\n    padding: 5px;\n    color: var(--textColour);\n    background-color: #f0f0f0;\n    font-size: 0.85rem;\n    border-top-right-radius: calc(var(--widgetBorderRadius) - 1px);\n    border-top-left-radius: calc(var(--widgetBorderRadius) - 1px);\n  }\n\n  .w-40 {\n    width: 40%;\n  }\n\n  .w-60 {\n    width: 60%;\n  }\n\n  .bid-state {\n    display: flex;\n    align-items: center;\n\n    .bid-state-inner {\n      padding-top: 15px;\n      padding-bottom: 15px;\n      flex-grow: 1;\n    }\n  }\n\n  .timer-date {\n\n    font-size: 11px;\n    color: var(--textLabelColour);\n    font-weight: 500;\n    text-transform: uppercase;\n\n  }\n\n\n  .with-you {\n    background-color: #09B677;\n    color: var(--colour3);\n  }\n\n  .against-you {\n    background-color: var(--dangerColour);\n    color: var(--colour3);\n  }\n\n  #bidAmt {\n    font-weight: 600 !important;\n  }\n\n  .bid-error {\n\n    background-color: var(--dangerColour);\n    color: #fff;\n    padding: 3px;\n    font-size: 12px;\n    font-weight: 500;\n    border-radius: 3px;\n    margin-top: 5px;\n\n  }\n\n  .ended {\n    font-size: 1rem;\n    font-weight: 500;\n    background-color: var(--dangerColour);\n    color: var(--colour3);\n  }\n\n  .tsandcs {\n    font-size: 0.75rem;\n  }\n\n  #bid-amount-box {\n    width: 100%;\n    margin: 0 auto;\n    text-align: center;\n  }\n\n  .minimum-bid {\n\n    font-size: 12px;\n    color: #666;\n\n    .minimum-bid-amount {\n      font-weight: 500;\n    }\n  }\n\n  h1 {\n    font-size: 24px;\n    font-weight: 500;\n  }\n\n  h2 {\n    font-size: 16px;\n    font-weight: 400;\n  }\n\n  .watchlist-state, .message-seller {\n    font-size: 0.8rem;\n    font-weight: 500\n  }\n\n  .buy-now-time-left {\n    text-align: center;\n    font-weight: 500;\n    text-transform: uppercase;\n    font-size: 0.75rem;\n    margin-top: 15px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
